const GOOGLE_IDENTITY_SCRIPT_SRC = 'https://accounts.google.com/gsi/client';

let googleIdentityScriptPromise;

export function getGoogleClientId() {
	return (process.env.REACT_APP_GOOGLE_CLIENT_ID || '846268011049-5sq8radlvjcb6s4seev5lp4lqoupl27p.apps.googleusercontent.com').trim();
}

export function loadGoogleIdentityScript() {
	if (window.google?.accounts?.id) {
		return Promise.resolve(window.google);
	}

	if (googleIdentityScriptPromise) {
		return googleIdentityScriptPromise;
	}

	googleIdentityScriptPromise = new Promise((resolve, reject) => {
		const existingScript = document.querySelector(`script[src="${GOOGLE_IDENTITY_SCRIPT_SRC}"]`);
		if (existingScript) {
			existingScript.addEventListener('load', () => resolve(window.google), { once: true });
			existingScript.addEventListener('error', () => reject(new Error('Failed to load Google Identity Services.')), { once: true });
			return;
		}

		const script = document.createElement('script');
		script.src = GOOGLE_IDENTITY_SCRIPT_SRC;
		script.async = true;
		script.defer = true;
		script.onload = () => resolve(window.google);
		script.onerror = () => reject(new Error('Failed to load Google Identity Services.'));
		document.body.appendChild(script);
	});

	return googleIdentityScriptPromise;
}

export async function initializeGoogleIdentity(callback) {
	const clientId = getGoogleClientId();
	if (!clientId) {
		return null;
	}

	const google = await loadGoogleIdentityScript();
	google.accounts.id.initialize({
		client_id: clientId,
		callback,
		ux_mode: 'popup',
		auto_select: false,
		cancel_on_tap_outside: true
	});

	return google;
}

export async function preloadGoogleIdentityScript() {
	if (!getGoogleClientId()) {
		return null;
	}

	return loadGoogleIdentityScript();
}
